import { createServerFn } from "@tanstack/react-start";
import { customInstance } from "@/lib/api/custom-instance";
import { logError, logInfo } from "@/lib/structured-log";

export interface ReferredUser {
  name: string;
  avatar_url?: string;
  status: "Registered" | "Activated" | "Paid" | string;
  reward_issued: boolean;
  joined_at: string;
}

export interface ReferralStatsResponse {
  referral_code: string;
  referral_link: string;
  deal_credits: number;
  total_referred: number;
  total_rewards: number;
  total_activated: number;
  referred_users: ReferredUser[];
}

export const getReferralStatsServer = createServerFn({ method: "GET" }).handler(
  async (): Promise<ReferralStatsResponse> => {
    const url = "/api/v1/referrals/me";
    const res = await customInstance<{ data: unknown; status: number; headers: Headers }>(url, {
      method: "GET",
      timeoutMs: 15000,
    });
    if (res.status !== 200) {
      logError("referrals.stats.non_ok", { status: res.status, url });
      throw new Error(`Failed to load referral stats: ${res.status}`);
    }
    const envelope = res.data as { code?: number; data?: ReferralStatsResponse; msg?: string };
    if (!envelope || envelope.code !== 0 || !envelope.data) {
      logError("referrals.stats.business_error", {
        status: res.status,
        code: envelope?.code,
        msg: envelope?.msg,
        url,
      });
      throw new Error(`Failed to load referral stats (business error): ${res.data}`);
    }
    const payload = envelope.data;
    logInfo("referrals.stats.loaded", {
      total_referred: payload.total_referred,
      total_activated: payload.total_activated,
      total_rewards: payload.total_rewards,
      deal_credits: payload.deal_credits,
    });
    return payload;
  },
);
